export { default } from './delivery-guarantee';